import React from 'react';

function NoAllergy() {
	return (
		<div className="practiceManagementForm" style={{ border: '1px solid #dadada' }}>
			<div className="noDataFound">
				<p>No Allergies Found</p>
			</div>
		</div>
	);
}
export default NoAllergy;
